var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"friends-modal",attrs:{"size":"lg","hide-footer":"","id":"friends-modal","no-close-on-backdrop":true,"title":"Друзья Up&Up"}},[_c('friends-list',{attrs:{"is-modal":true},on:{"startChat":_vm.startChat}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }